export const convertStringToFloat = (value: string) => {
  value = value.replaceAll(".", "");
  value = value.replace(",", ".");
  return Number.parseFloat(value);
};

export const convertStringDotToFloat = (value: string) => {
  if (value.includes('.') && value.includes(',')) {
    return convertStringToFloat(value);
  } else {
    if (value.includes(',')) {
      value = value.replace(",", ".");
    }

    return Number.parseFloat(value);
  }
};

export const convertStringToFloatCurrency = (value: string) => {
  const valueConvert = value.replaceAll(',', '.');
  const options: Intl.NumberFormatOptions = { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' };

  if (valueConvert !== '') {
    return new Intl.NumberFormat('pt-BR', options).format(parseFloat(valueConvert));
  }

  return '';
};